import React, { useEffect } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * This component is used to trigger events during other component's mount process.
 * Useful, if you want to let someone do something with the DOM once component has rendered with data.
 */
export const EventTrigger: React.FC<{ eventName: string; eventArgs: any }> = ({
    eventName,
    eventArgs
}) => {
    const isMounted = useIsMounted();

    useEffect(() => {
        isMounted() && publicEventsAPIService.trigger(eventName, eventArgs);
    }, [
        isMounted,
        eventName,
        eventArgs
    ]);

    return null;
};
